<template>
    <span>
        <home-hero
            headline="How it works"
            text="We are volunteers who dedicate our time and skills to contribute to projects, product ideas, engagement and research. We rely on lateral leadership exercised by everybody, therefore we hope that everybody joining actively engages and lead initiatives on various levels.
                "
            button
            paddinghero
        ></home-hero>
        <div class="bg-white">
            <v-container grid-list-lg px-5 class="pb-big">
                <v-layout row wrap>
                    <v-flex xs12 sm12 md3>
                        <v-hover>
                            <v-card>
                                <v-card-text class="not-rounded-card-how">
                                    <div>
                                        <h2 class="color-blue">
                                            Athena Platform
                                        </h2>
                                        <br />
                                        <div>
                                            Athena fosters collaboration and
                                            communication by bringing people
                                            together who are passionate about
                                            making a difference. We welcome
                                            everybody and provide an environment
                                            for contributors to drive, grow and
                                            to make a real impact.
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-flex>
                    <v-flex xs12 sm12 md3>
                        <v-hover>
                            <v-card>
                                <v-card-text class="not-rounded-card-how">
                                    <div>
                                        <h2 class="color-blue">Work Streams</h2>
                                        <br />
                                        <div>
                                            A work stream derives data insights
                                            or digital products to the public
                                            with clear mission and goals
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-flex>
                    <v-flex xs12 sm12 md3>
                        <v-hover>
                            <v-card>
                                <v-card-text class="not-rounded-card-how">
                                    <div>
                                        <h2 class="color-blue">
                                            Athena Committee
                                        </h2>
                                        <br />
                                        <div>
                                            The committee is made up of the Work
                                            Stream Leads who represents Project
                                            Athena to the public, synchronises
                                            workstreams and gives guidance and
                                            direction. WORK STREAMS - A
                                            workstream derives data insights or
                                            digital products to the public with
                                            clear mission and goals.
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-flex>
                    <v-flex xs12 sm12 md3>
                        <v-hover>
                            <v-card>
                                <v-card-text class="not-rounded-card-how">
                                    <div>
                                        <h2 class="color-blue">
                                            Work Stream Lead
                                        </h2>
                                        <br />
                                        <div>
                                            The Product Owner for the Work
                                            Stream represents the work Stream in
                                            the Athena Committee and services
                                            across different work streams to
                                            assist and offer guidance.
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container class="pb-big">
                <v-layout row wrap px-4>
                    <v-flex xs12 sm12 md3 class="pa-3 justify-space-around">
                        <v-card>
                            <v-responsive>
                                <v-img
                                    :src="require('../assets/img/5.png')"
                                    height="183px"
                                >
                                    <v-container fill-height fluid>
                                        <v-layout fill-height>
                                            <v-flex xs12 align-end flexbox>
                                                <span class="white--text">
                                                    Discuss & Develop
                                                </span>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-img>
                            </v-responsive>
                            <v-card-text>
                                <div>
                                    <h3 class=" mb-2">
                                        Discuss & develop a hypothesis
                                    </h3>
                                    <div>
                                        Bring an idea or product that you think
                                        would be crucial to the cause, discuss
                                        it and develop a hypothesis
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex
                        style="position: relative; top: 150px; left: 30px;"
                        class="mobile-hide"
                    >
                        <img src="../assets/img/yellowtriangle.png" alt="" />
                    </v-flex>
                    <v-flex style="" class="mobile-show text-xs-center">
                        <img
                            src="../assets/img/yellowtriangle_mobile.png"
                            alt=""
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md3 class="pa-3 justify-space-around">
                        <v-card>
                            <v-responsive>
                                <v-img
                                    :src="require('../assets/img/8.png')"
                                    height="183px"
                                >
                                    <v-container fill-height fluid>
                                        <v-layout fill-height>
                                            <v-flex xs12 align-end flexbox>
                                                <span class="white--text">
                                                    Identify & Contribute
                                                </span>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-img>
                            </v-responsive>
                            <v-card-text>
                                <div>
                                    <h3 class=" mb-2">How does it work?</h3>
                                    <div>
                                        Once a hypothesis is identified, we
                                        identify a work stream lead, skills and
                                        contributors to become the project team
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex
                        style="position: relative; top: 150px; left: 30px;"
                        class="mobile-hide"
                    >
                        <img src="../assets/img/yellowtriangle.png" alt="" />
                    </v-flex>

                    <v-flex style="" class="mobile-show text-xs-center">
                        <img
                            src="../assets/img/yellowtriangle_mobile.png"
                            alt=""
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md3 class="pa-3 justify-space-around">
                        <v-card>
                            <v-responsive>
                                <v-img
                                    :src="require('../assets/img/7.png')"
                                    height="183px"
                                >
                                    <v-container fill-height fluid>
                                        <v-layout fill-height>
                                            <v-flex xs12 align-end flexbox>
                                                <span class="white--text">
                                                    Drive Change
                                                </span>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-img>
                            </v-responsive>

                            <v-card-text>
                                <div>
                                    <h3 class=" mb-2">Move fast!</h3>
                                    <div>
                                        Everyone drives the project through
                                        tasks and deadlines to bring quick
                                        results
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <home-footer></home-footer>
    </span>
</template>

<script>
import HomeHero from '@/components/HomeHero';
import HomeDetails from '@/components/HomeDetails';
import HomeProjects from '@/components/HomeProjects';
import HomeFooter from '@/components/HomeFooter';

export default {
    name: 'how-it-works',
    components: {
        HomeHero,
        HomeDetails,
        HomeProjects,
        HomeFooter
    }
};
</script>
